import { gql } from '@apollo/client';

import { COGNITO_STATE_FRAGMENT } from '../queries/getUserCognitoState.gql';

export const SYNC_COGNITO_USER = gql`
  mutation SyncCognitoUser($id: ID!) {
    syncCognitoUser(id: $id) {
      ... on SyncCognitoUserSuccess {
        __typename
        state {
          ...CognitoStateFragment
        }
      }
      ... on SyncCognitoUserFailure {
        __typename
        failureMessage: message
        responseType
      }
      ... on NotFoundError {
        message
        responseType
        __typename
      }
      ... on AuthorizationFailure {
        message
        responseType
        __typename
      }
      __typename
    }
  }

  ${COGNITO_STATE_FRAGMENT}
`;
